import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { StyleProp, View, ViewStyle } from 'react-native';

const BUBBLES: { height: number; sent: boolean; width: string }[] = [
  { height: 40, sent: true, width: '44%' },
  { height: 72, sent: false, width: '70%' },
  { height: 40, sent: true, width: '36%' },
  { height: 56, sent: false, width: '62%' },
  { height: 40, sent: true, width: '48%' },
];
const MIN_OPACITY = 0.3;
const FADE_STEP = (1 - MIN_OPACITY) / (BUBBLES.length - 1);

interface AgentThreadSkeletonProps {
  style?: StyleProp<ViewStyle>;
}

export const AgentThreadSkeleton: React.FC<AgentThreadSkeletonProps> = ({
  style,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.superintelligence.loading_conversation',
      )}
      aria-busy
      style={[styles.container, style]}
    >
      {BUBBLES.map((bubble, index) => (
        <View
          key={index}
          style={[
            bubble.sent ? styles.rowEnd : styles.rowStart,
            { opacity: 1 - index * FADE_STEP },
          ]}
        >
          <Skeleton
            borderRadius={theme.sk.radii.radiusLarge}
            height={bubble.height}
            width={bubble.width}
          />
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceMedium,
    width: '100%',
  },
  rowEnd: {
    alignItems: 'flex-end',
    width: '100%',
  },
  rowStart: {
    alignItems: 'flex-start',
    width: '100%',
  },
}));
